// import {extractFieldsFromLayout} from "src/services/surveyFields";
let fixedValueTypes = ['RACE', 'GENDER', 'DROPDOWN', 'SINGLE_CHOICE', 'SINGLE_CHOICE_GENDER', 'SINGLE_CHOICE_RACE', 'SINGLE_CHOICE_UNIT', 'SINGLE_CHOICE_SHIFT', ]
let fixedValueMultiTypes = ['MULTI_CHOICE', 'MULTI_CHOICE_TOF' ]
let ignoredFields = ['ATTACHMENTS','PHOTOS','LOCATION']
let listFields = ['LIST']

const dictationModes = {
  raw: {
    label: 'Raw',
    description: 'Keep the dictated wording and only organize it into report fields.',
    instruction: 'Keep comment wording as close to the original narrative as possible. Do not rewrite for style. Only make changes required to place the narrative into the correct form fields.'
  },
  moderate: {
    label: 'Moderate',
    description: 'Improve grammar and readability while keeping the original tone.',
    instruction: 'Lightly rewrite comments to correct grammar, punctuation, and sentence flow. Preserve the original tone, meaning, and level of detail.'
  },
  professional: {
    label: 'Professional',
    description: 'Rewrite comments in concise, formal report language.',
    instruction: 'Rewrite comments in clear, concise, professional report language. Improve structure and remove conversational phrasing while preserving the original meaning and level of detail.'
  }
}

const getFieldType = (field) => {
  if(fixedValueTypes.includes(field.questionType)) {
    return "SINGLE_CHOICE"
  }
  if(fixedValueMultiTypes.includes(field.questionType)) {
    return "MULTIPLE_CHOICE"
  }

  return "TEXT"
}

const getOperator = (field) => {
  if(fixedValueTypes.includes(field.questionType) || fixedValueMultiTypes.includes(field.questionType)) {
    return undefined
  }

  return ["iLike", "gte", "lte", "between"]
}


const normalizeReportLayout = (report) => {
  let layout = report.layout.filter(field => field.type !== 'header');
  let normalizedFields = []

  for(let i = 0; i < layout.length; i++) {
    let field = layout[i];

    if(field.schema === 'rating-multi') {
      normalizedFields.push({
        fieldId: field.id,
        fieldIndex: i,
        title: field.ratingPrompt,
        type: 'RATING',
        defaultComments: field.defaultComments,
        requiredTimeSpendRatings: field.requiredTimeSpendRatings,
        note: 'The field is used for rating officer on performance, default comments are narrative that matches the rating'
      })
    }

    if(['comment', 'pto-rating-comment'].includes(field.schema)) {
      normalizedFields.push({
        fieldId: field.id,
        fieldIndex: i,
        title: field.prompt,
        type: 'COMMENT',
        note: 'The field is used for comment'
      })
    }
  }

  return normalizedFields;
}

const isCommentRequiredForRating = (value, requiredComments) => {
  return (requiredComments || []).find(rc => rc === value)
}
const isNextValueValid = (value, requiredComments, requiredTimeSpendRatings) =>  {
  return (isCommentRequiredForRating(value.rating, requiredComments) ? !!value.comment : true) &&
    (value.notResponsive ? !!value.comment : true) &&
    (!(requiredTimeSpendRatings || []).find(rating => rating === value.rating) || Number(value.timeSpend) > 0) &&
    (value.rating || value.notResponsive || value.notObserved)
}


const normalizeResponse = (result, report) => {
  let res = []
  let layout = report.layout;
  for(let i = 0; i < result.length; i++) {
    let fieldRes = result[i];
    let fieldIndex = layout.findIndex(l => l.id === fieldRes.fieldId)
    let field = layout[fieldIndex];

    if(field) {
      switch (field.schema) {
        case 'rating-multi':
          let val = {
            sequence: fieldIndex.toString(),
            comment: fieldRes.comment || "",
            notObserved: fieldRes.notObserved,
            notResponsive: fieldRes.notResponsive,
            rating: fieldRes.rating,
            timeSpend: fieldRes.timeSpend,
          }
          val.isValid = isNextValueValid(val, field.requiredComments, field.requiredTimeSpendRatings)
          res.push(val)
          break;
        case 'pto-rating-multi':
          res.push({
            sequence: fieldIndex.toString(),
            observationComment: fieldRes.comment || "",
            isValid: !!fieldRes.comment
          })
          break;

        case 'comment':
          res.push({
            sequence: fieldIndex.toString(),
            comment: fieldRes.comment || "",
            isValid: !!fieldRes.comment
          })
          break;

        default:
          console.log('SCHEMA NOT FOUND', fieldRes, field)
      }
    }
  }

  return res;
}


const getFillFormPrompt = (reportFields, dictationMode = 'raw') => {
  let mode = dictationModes[dictationMode] || dictationModes.raw

  return (
  `You are a tool that reads a user narrative and uses that narrative to fill in form
The following json describes all the fields that are part of that form
${JSON.stringify(reportFields)}

Comment editing level: ${mode.label}
${mode.instruction}

For every editing level:
- Preserve all facts, names, dates, quoted speech, ratings, and observations from the narrative.
- Do not add facts, conclusions, conduct, or observations that the user did not provide.
- Do not intensify or soften an assessment.
- If the narrative does not contain information for a field, omit that field from the response.

Return only valid JSON in the following format, without markdown fences or explanatory text:

[{
 "fieldId": The id of the field,
 "index": The index of the field,
 "rating": The field is set to rating from 1-5 depending on the observation done or if score is explicitly set; if the rating is not observed (NO) or not responsive to training (NRT), it is set to zero (0),
 "notObserved": The field is set to true if the rating is not observed (NO), otherwise it is set to false,
 "notResponsive": The field is set to true if the rating is not responsive to training (NRT), otherwise it is set to false,
 "comment": The field is set when there is additional comments other than the rating, not observed (NO) and not responsive to training (NRT)
}]
`)
}



export default {
  dictationModes,
  normalizeReportLayout,
  normalizeResponse,
  getFillFormPrompt,
}
